export default "__VITE_ASSET__68202acc__"